import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import MovieCard from '@/components/feature/MovieCard';
import EmptyState from '@/components/feature/EmptyState';
import { getMovieById } from '@/utils/movie';
import { useFavorites } from '@/hooks/useFavorites';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function FavoritesPage() {
  const { favoriteIds, clearFavorites } = useFavorites();
  usePageMeta('我的收藏 - 亚洲中文字幕在线观看', '查看你在亚洲中文字幕在线观看收藏的影视作品，收藏记录保存在本地浏览器。');

  const list = favoriteIds
    .map((id) => getMovieById(id))
    .filter((movie): movie is NonNullable<typeof movie> => Boolean(movie));

  return (
    <Layout>
      <div className="w-full px-4 md:px-8 py-6 md:py-8">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div>
            <h1 className="font-heading font-black text-2xl md:text-3xl text-foreground-950 flex items-center gap-2">
              <i className="ri-heart-fill text-accent-500"></i>
              我的收藏
            </h1>
            <p className="mt-2 text-sm text-foreground-500">
              收藏记录保存在本地浏览器，关闭后再次访问依然保留。
            </p>
          </div>
          {list.length > 0 && (
            <button
              type="button"
              onClick={clearFavorites}
              className="px-4 h-9 flex items-center gap-1 rounded-md border border-background-300 text-sm text-foreground-600 hover:border-accent-400 hover:text-accent-500 cursor-pointer whitespace-nowrap transition-colors"
            >
              <i className="ri-delete-bin-line"></i>
              清空收藏
            </button>
          )}
        </div>

        <div className="mt-6">
          {list.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-5">
              {list.map((movie) => (
                <MovieCard key={movie.id} movie={movie} />
              ))}
            </div>
          ) : (
            <EmptyState
              icon="ri-heart-line"
              title="还没有收藏任何作品"
              description="在影片卡片或详情页点击爱心，就能把喜欢的作品收藏到这里。"
            />
          )}
          {list.length === 0 && (
            <div className="flex justify-center">
              <Link
                to="/category/hot"
                className="px-5 h-10 flex items-center gap-2 rounded-md bg-primary-500 text-background-950 text-sm font-medium hover:bg-primary-600 cursor-pointer whitespace-nowrap transition-colors"
              >
                <i className="ri-fire-line"></i>
                去看看热门影视
              </Link>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}